import createActionType from "../utils/createActionType";

export const MODULE = "materialsv2";

export const SEARCH_MATERIALS = createActionType(MODULE, "searchMaterials");
